
import { GL_Master, GL_Master_Save } from '../models/GL_Master';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Http, Headers } from '@angular/http';
import { GL_Child } from '../models/GL_Child';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/share';
import 'rxjs/add/observable/of';
import { CardInfo } from '../models/GL_Card_Info';


@Injectable()

export class GL_MasterService {
  //private readonly GL_MasterEndpoint = 'http://localhost:64330/api';
  private readonly GL_MasterEndpoint = '/api';
  headers: any;
  data;
  observable;

  //gl_childs_cache:any[] ;

  constructor(
    //private http: HttpClient,
    private http: Http) {
    this.headers = new Headers({ 'Content-Type': 'application/json' });
    this.headers.append('Content-Type', 'application/json');
    let authToken = localStorage.getItem('auth_token');
    this.headers.append('Authorization', `Bearer ${authToken}`);
  }
  getStudentDetails(GL_ChildCode: string, semester: number) {
     
    return this.http.get(this.GL_MasterEndpoint + `/GL_Child/getStudentDetails?GL_ChildCode=${GL_ChildCode}&semester=${semester}`);
  }
  getStudentName(GL_ChildCode: string) {
    return this.http.get(this.GL_MasterEndpoint + `/GL_Child/getStudentName/${GL_ChildCode}`, { headers: this.headers });
  }

  getStudentStatusTerm(StudentId: string) {
    return this.http.get(this.GL_MasterEndpoint + `/Txn_Invoice/getStudentStatusTerm?studentId=${StudentId}`, { headers: this.headers });
  }

  getDepartments() {
    return this.http.get(this.GL_MasterEndpoint + '/GL_Master/AllDepartments/').map(d => d.json());
  }
  getAllChilds() {
    return this.http.get(this.GL_MasterEndpoint + '/GL_Master/Get_GL_Childs', { headers: this.headers })
      .map(res => res.json());
  }
  getGL_Masters(category: string, branchId:number) {

    return this.http.get(this.GL_MasterEndpoint + '/GL_Master/' + category + '/' + branchId, { headers: this.headers })
      .map(res => res.json());
  }


  //  getBankCash_Masters() {
  //      return this.http.get(this.GL_MasterEndpoint + '/BankCash_Master',{headers: this.headers}  )
  //          .map(res => res.json());
  //}

  AddGL_Master(gl_Master: GL_Master_Save) {
    return this.http.post(this.GL_MasterEndpoint + '/GL_Master/', gl_Master, { headers: this.headers })
      .map(res => res.json());
  }
  DeleteGL_Master(gl_master_code: string) {
    return this.http.delete(this.GL_MasterEndpoint + '/GL_Master/' + gl_master_code, { headers: this.headers })
      .map(res => res.json());
  }
  getGL_Childs(GL_code: string , branchId:number) {
    if (GL_code != 'A00001')  // A bad hard code ! remove it later.
    {
      return this.http.get(this.GL_MasterEndpoint + '/GL_Child/getGet_GL_ChildsNotStudent/' + GL_code + '/' + branchId, { headers: this.headers })
        .map(res => res.json());
    }
    // if gl master is student account...
    if (this.data) {
      console.log(`read from data...` + this.data)
      return Observable.of(this.data);
    } else if (this.observable) {
      console.log(`read from observable...` + this.observable)
      return this.observable;
    } else {
      console.log('read from server...')
      this.observable = this.http.get(this.GL_MasterEndpoint + '/GL_Child/getGet_GL_Childs/' + GL_code, { headers: this.headers })
        .map(response => {
          this.observable = null;
          if (response.status === 400) {
            return 'Request failed.';
          } else if (response.status === 200) {
            this.data = response.json();
            return this.data;
          }
        })
        .share();
      return this.observable;
    }

    //return this.http.get(this.GL_MasterEndpoint + '/GL_Child/getGet_GL_Childs/' + GL_code,{headers: this.headers})
    //.map(res => res.json())
  }

  getGL_Childsp(GL_code: string, pageIndex: number, pageSize: number, GL_Child_Code: string, GL_Child_Name: string) {
    if (GL_code != 'A00001')  // A bad hard code ! remove it later.
    {
      return this.http.get(this.GL_MasterEndpoint + '/GL_Child/getGet_GL_ChildsNotStudent/' + GL_code +'/0', { headers: this.headers })
        .map(res => res.json());
    }
    // if gl master is student account...
    //if (this.data) {
    //  console.log(`read from data...` + this.data)
    //  return Observable.of(this.data);
    //} else if (this.observable) {
    //  console.log(`read from observable...` + this.observable)
    //  return this.observable;
    //} else {
    console.log('read from server...')
    this.observable = this.http.get(this.GL_MasterEndpoint + '/GL_Child/getGet_GL_Childs/' + GL_code + `/${pageIndex}/${pageSize}/${GL_Child_Code}/${GL_Child_Name}`, { headers: this.headers })
        .map(response => {
          this.observable = null;
          if (response.status === 400) {
            return 'Request failed.';
          } else if (response.status === 200) {
            this.data = response.json();
            return this.data;
          }
        })
        .share();
      return this.observable;
    }

    //return this.http.get(this.GL_MasterEndpoint + '/GL_Child/getGet_GL_Childs/' + GL_code,{headers: this.headers})
    //.map(res => res.json())
  //}
  getRecordCount(GL_Code: string, GL_Child_Code: string, GL_Child_Name: string) {
    return this.http.get(this.GL_MasterEndpoint + '/GL_Child/getChildsRecordCount/' + `${GL_Code}/${GL_Child_Code}/${GL_Child_Name}`, { headers: this.headers });
  }
  AddGL_child(gl_child: GL_Child) {
    return this.http.post(this.GL_MasterEndpoint + '/GL_Child/', gl_child, { headers: this.headers })
      .map(res => res.json());
  }

  DeleteGL_Child(gl_child_code: string) {
    return this.http.delete(this.GL_MasterEndpoint + '/GL_Child/' + gl_child_code, { headers: this.headers })
      .map(res => res.json());
  }

  getGL_Category() {
    return this.http.get(this.GL_MasterEndpoint + '/GL_Category', { headers: this.headers })
      .map(res => res.json());
  }
  EditGL_child(gl_child: GL_Child) {  //  --------
    return this.http.post(this.GL_MasterEndpoint + '/GL_Child/Edit/', gl_child)
      .map(res => res.json()).catch(() => {
        return Observable.of(false);
      });
  }
  getGLLedgers(gl_child_code: string) {
    return this.http.get(this.GL_MasterEndpoint + '/GL_Ledger/' + gl_child_code, { headers: this.headers })
      .map(res => res.json());
  }

  getNotInitFixAssests(GL_code: string) {
    return this.http.get(this.GL_MasterEndpoint + '/GL_Child/getNotInitFixAssests/' + GL_code, { headers: this.headers })
      .map(res => res.json());
  }

  getCardInfo(studentId: string) {
    return this.http.get(this.GL_MasterEndpoint + '/GL_Child/getCardInfo/' + studentId, { headers: this.headers })
      .map(res => res.json());
  }

  getCards(stuId: string, fromDate: string, toDate: string, semester: number, st_department: string, type_card: number, branchId: number, userId: string) {
    return this.http.get(this.GL_MasterEndpoint + '/GL_Child/getCards/?StuId=' + stuId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&semester=" + semester + "&department=" + st_department + "&type_card=" + type_card + "&branchId=" + branchId + "&userId=" + userId);
  }

  postPrintCard(cardInfo: CardInfo) {
    return this.http.post(this.GL_MasterEndpoint + '/GL_Child/Create_Card', cardInfo, { headers: this.headers })
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/Acc_GL_Master.service.ts